import { useCallback, useEffect, useState } from "react";

export function useScreenWidth(): number {
  const [width, setWidth] = useState(window.innerWidth);

  const handler = useCallback((event: any) => {
    setWidth(event.target.innerWidth);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handler);

    return () => {
      window.removeEventListener("resize", handler);
    };
  }, [handler]);

  return width;
}
